import React, { CSSProperties } from "react";
import { MentionText } from "@adsk/acc-mention";

export const IssueCommentBlock = ({
  commentBody,
  style,
}: {
  commentBody: string;
  showMoreFromLength?: number;
  style?: CSSProperties;
}) => {
  return <MentionText value={commentBody} style={style} />;
};
